module.exports = __webpack_public_path__ + "img/zerospam_logo-850x-opti.ad126ea0.png";